module.exports = __webpack_public_path__ + "static/media/footer_bg.e6cf71c8.png";